import { createSlice } from "@reduxjs/toolkit";

const spaceRolesSlice = createSlice({
  name: "getSpaceRoles",
  initialState: [],
  reducers: {
    setSpaceRoles: (_state, action) => action.payload,
  },
});

export const { setSpaceRoles } = spaceRolesSlice.actions;

export const getSpaceRoles = spaceRolesSlice.reducer;

export default spaceRolesSlice.reducer;
